// extracted by mini-css-extract-plugin
export default {"container":"settingsCard_container__gWKez","coinsValue":"settingsCard_coinsValue__ufvMu","coinsDetail":"settingsCard_coinsDetail__pSf6q"};